import InstrumentFollowButton from '@/library/entities/market/instrument/components/InstrumentFollowButton'
import NextImageV2 from '@/library/blocks/images/NextImageV2'
import { Route } from '@/routers/routes'
import Link from 'next/link'
import React from 'react'

export default function InstrumentListItem(props) {
  const {
    item,
    className = '',
  } = props
  const href = Route.instrumentDetail(item)
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <Link href={href}>
        <NextImageV2
          src={item.logotype}
          alt={item.name}
          containerWidth={206}
          containerHeight={128}
          imageWidth={300}
          imageHeight={128}
          className={`w-full h-32 rounded-xl `}
          objectFit='contain'
          imageContain={true}
          addPadding={true}
        />
      </Link>
      <Link href={href} className='flex flex-col items-center gap-2'>
        <h3 className='text-md font-bold text-zink-200 text-center'>{item.name}</h3>
        <p className='text-sm text-zink-200 text-center'>{item.market_name}</p>
      </Link>
      <div className='flex justify-center'>
        <InstrumentFollowButton
          className=''
          appName='market'
          modelName='instrument'
          entityId={item.pk}
        />
      </div>
    </div>
  )
}
